const initialState = {
    "dotsActive": ["dot-active", "", ""],
    "dotsDisplay": ["", "", ""],
    "mostraratras": false
}

export function polizasMovilRdc(state = initialState, action) {
    switch (action.type) {
        case "SET_DOT_ACTIVE":
            return {...state,
                "dotActive": action.arreglo
            }
        case "SET_DOT_DISPLAY":
            return {...state,
                "dotDisplay": action.arreglo
            }
        case "SET_MOSTRAR_ATRAS":
            return {...state,
                "mostraratras": action.atras
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/movil/polizas/reducer.js